import { React, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as AddSquareIcon } from '../../../../assets/images/AddSquareIcon.svg';
import { ReactComponent as GlobeIcon } from '../../../../assets/images/GlobeIcon.svg';
import { ReactComponent as GreenPlusIcon } from '../../../../assets/images/GreenPlusIcon.svg';
import Tooltip from '../../../../components/shared/Tooltip/Tooltip';

import AddEducationModal from './AddEducationModal/AddEducationModal';
import EducationDetails from './EducationDetails';

import styles from './Education.module.scss';

const Education = ({ educationData = {}, allowEdit, handleProfileUpdate }) => {
  const { t } = useTranslation('common');
  const [showModal, setShowModal] = useState(false);
  const [formValues, setFormValues] = useState({});

  useEffect(() => {
    if (!showModal) {
      setFormValues({});
    }
  }, [showModal]);

  const handleOpenModal = useCallback((data = {}) => {
    setFormValues(data);
    setShowModal(true);
  }, []);

  const closeModal = useCallback(() => {
    setShowModal(false);
  }, []);

  const handleSave = useCallback((data) => {
    handleProfileUpdate({ user_educations_attributes: data }, closeModal());
  }, []);

  return !allowEdit && educationData.length === 0 ? null : (
    <div className={styles.container}>
      <div className={styles.headerWrapper}>
        <div className={styles.containerHeading}>
          <div className={styles.heading}>{t('account.education')}</div>
          {allowEdit && (
            <Tooltip text={t('profile.sectionIsPublic')}>
              <span className={styles.headingGlobe}>
                <GlobeIcon />
              </span>
            </Tooltip>
          )}
        </div>
        {allowEdit && educationData.length !== 0 && (
          <div>
            <button type="button" onClick={() => handleOpenModal({})} className={styles.addExperience}>
              <AddSquareIcon />
            </button>
          </div>
        )}
      </div>
      <div className={styles.containerBody}>
        {Object.keys(educationData).length ? (
          <EducationDetails educationData={educationData} allowEdit={allowEdit} handleOpenModal={handleOpenModal} />
        ) : (
          <div className={styles.noEducation}>
            <button type="button" className={styles.noEducationButton} onClick={() => handleOpenModal({})}>
              <GreenPlusIcon /> <span className={styles.noEducationText}>{t('profile.addEducation')}</span>
            </button>
          </div>
        )}
      </div>
      {showModal && (
        <AddEducationModal
          showModal={showModal}
          setShowModal={setShowModal}
          initialValues={formValues}
          handleSave={handleSave}
          formData={educationData}
        />
      )}
    </div>
  );
};

export default Education;
